// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5nJyq","col":"styles_col__bsW6z"};